module.exports = __webpack_public_path__ + "dda0f8ebc72de9db0fef672dcb5c086a.png";